<template>
    <div
        class="mb-6 rounded-xl bg-light-gray p-8 drop-shadow-[0_0_8px_rgba(20,20,20,0.1)]"
    >
        <div class="mb-4">
            <Icon name="quote-left" class="text-[50px]" />
        </div>
        <WysiwygContent :content="section.testimonial" class="mb-6" />
        <h4 class="mb-2">{{ section.name }}</h4>
        <p class="text-[14px]">{{ section.businessName }}</p>
    </div>
</template>

<script setup lang="ts">
import type { TestimonialCardType } from '#shared/types/TestimonialCardType';

defineProps<{
    section: TestimonialCardType;
}>();
</script>
